jQuery(document).ready(function ($) {
    $(".inline").colorbox({inline:true, width:"80%"});

    $(document).bind('cbox_open', function(){
        $('body').addClass('no-scroll');
    });
    $(document).bind('cbox_closed', function(){
        $('body').removeClass('no-scroll');
    });
});


// document.getElementById('affirmCheckoutBtn').addEventListener('click', function() {

//     // Get the selected variant dynamically
//     var variantId = {{ product.selected_or_first_available_variant.id }};
//     var productTitle = "{{ product.title }}";
//     var sku = "{{ product.selected_or_first_available_variant.sku }}";
//     var priceInCents = {{ product.selected_or_first_available_variant.price | times: 1 }}; // Already in cents

//     // Build Affirm checkout object
//     affirm.checkout({
//       merchant: {
//         user_confirmation_url: "https://zpodsforsleep.com/affirm/confirm",
//         user_cancel_url: "https://zpodsforsleep.com/affirm/cancel",
//         public_api_key: "1KCORW3OLEHUDI0V",
//         user_confirmation_url_action: "POST",
//         name: "{{ shop.name }}"
//       },
//       items: [{
//         display_name: productTitle,
//         sku: sku,
//         unit_price: priceInCents,
//         qty: 1
//       }],
//       total: priceInCents
//     });

//     // Open Affirm popup
//     affirm.checkout.open();
// });
